import { Ban, Mail } from 'lucide-react';

export default function RestrictedAccountModal({ restrictionReason }) {
  return (
    <div className="fixed inset-0 bg-black z-[100] flex items-center justify-center p-4">
      <div className="bg-zinc-900 border border-red-500 max-w-md w-full">
        {/* Header */}
        <div className="bg-red-500/20 border-b border-red-500/50 p-6 text-center">
          <div className="w-16 h-16 mx-auto mb-4 bg-red-500/20 rounded-full flex items-center justify-center">
            <Ban className="w-8 h-8 text-red-500" />
          </div>
          <h2 className="font-mono text-xl text-red-500 font-bold">ACCOUNT RESTRICTED</h2>
        </div>

        {/* Content */}
        <div className="p-6 space-y-4">
          <p className="font-mono text-sm text-zinc-300 text-center">
            Your account has been restricted and you cannot access this site.
          </p>
          
          {restrictionReason && (
            <div className="p-4 bg-zinc-800 border border-zinc-700">
              <p className="font-mono text-[10px] text-zinc-500 uppercase tracking-wider mb-2">Reason</p>
              <p className="font-mono text-sm text-white">{restrictionReason}</p>
            </div>
          )}

          <div className="p-4 bg-zinc-800/50 border border-zinc-700">
            <p className="font-mono text-xs text-zinc-400 text-center">
              If you believe this is an error, please contact support:
            </p>
            <a 
              href="mailto:support@shopblkmrkt.com" 
              className="flex items-center justify-center gap-2 mt-3 font-mono text-sm text-tiffany-500 hover:text-tiffany-400 transition-colors"
            >
              <Mail className="w-4 h-4" />
              support@shopblkmrkt.com
            </a>
          </div>
        </div>

        {/* Footer */}
        <div className="border-t border-zinc-800 p-4 bg-zinc-900/50">
          <p className="font-mono text-[10px] text-zinc-600 text-center">
            You cannot access any features while your account is restricted.
          </p>
        </div>
      </div>
    </div>
  );
}
